import { createContext } from 'react';
import type { TourRole } from './tours';

export interface TourContextValue {
  startTour: (role: TourRole) => void;
  stopTour: () => void;
}

export const TourContext = createContext<TourContextValue | null>(null);
